import { render, staticRenderFns } from "./PhoneItem.vue?vue&type=template&id=55e47df9&scoped=true&"
import script from "./PhoneItem.vue?vue&type=script&lang=js&"
export * from "./PhoneItem.vue?vue&type=script&lang=js&"
import style0 from "./PhoneItem.vue?vue&type=style&index=0&id=55e47df9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e47df9",
  null
  
)

export default component.exports